module.exports = __webpack_public_path__ + "static/img/35.8b05aeba.png";